import { combineReducers } from "redux";
import { IStore } from "../../interfaces/IStore";
import user from "./userReducer";

export default combineReducers<IStore>({
  user,
});
